<template>
    <div class="form-group">
        <label class="label">Inland Freight</label>
        <div class="row p-0">
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayData"
                    :placeholder="'Data'"
                    :required="true"
                    :disabled="is_view"
                    @blur="rawInputData = ''" 
                />
            </div>
            <div class="col-6 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    @input="updateValue"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InlandFreight',
    props: {
        value: {
            type: Object,
            default: () => ({
                data: '',
                value: ''
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            isTypingDotData: false,
            rawInputData: '',  
            internalValue: { ...this.value }
        };
    },
    computed: {
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === undefined || val === '') return '$ 0.000';
                
                // Usamos Intl.NumberFormat para manejar millones y decimales
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3
                }).format(val);
            },
            set(newValue) {
                let cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                let numericValue = parseFloat(cleanValue);
                this.internalValue.value = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        },
       displayData: {
            get() {
                const val = this.internalValue.data;
                if (val === null || val === '') return this.rawInputData || '$ 0';

                // Si el usuario está escribiendo, mostramos el raw
                if (this.rawInputData !== '') return '$ ' + this.rawInputData;

                return '$ ' + new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInputData = cleanValue;  // guardamos el string tal cual

                if (cleanValue.endsWith('.')) {
                    this.isTypingDotData = true;
                    return;
                }

                this.isTypingDotData = false;

                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);

                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.data = numericValue;
                    this.updateValue();
                }
            }
        },
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        },
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>